import { render, staticRenderFns } from "./ContactLinzCategory.vue?vue&type=template&id=d9223078&"
import script from "./ContactLinzCategory.vue?vue&type=script&lang=js&"
export * from "./ContactLinzCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports